<template>
  <h3 class="room-title">
    {{ $store.getters.currentRoomTypeTitleData?.ROOM_TITLE || '' }}<template v-if="bedVariant.length || smokingVariant.length || adaVariant.length">, </template>

    <template v-if="bedVariant.length">
      <a v-if="bedOptions.length > 1"
           @click.prevent="$store.commit('updateState', ['isVariantDialogVisible', true])"
           title="Click for room options" href="#">{{ bedVariant }}</a>
      <span v-else>{{ bedVariant }}</span><template v-if="smokingVariant.length || adaVariant.length">, </template>
    </template>

    <template v-if="smokingVariant.length">
      <a v-if="smokingVariants.length > 1"
           @click.prevent="$store.commit('updateState', ['isVariantDialogVisible', true])"
           title="Click for room options" href="#">{{ smokingVariant }}</a>
      <span v-else>{{ smokingVariant }}</span><template v-if="adaVariant.length">, </template>
    </template>

    <template v-if="adaVariant.length">
      <a v-if="adaVariants.length > 1"
         @click.prevent="$store.commit('updateState', ['isVariantDialogVisible', true])"
         title="Click for room options" href="#">{{ adaVariant }}</a>
      <span v-else>{{ adaVariant }}</span>
    </template>
  </h3>
</template>

<script lang="ts">
/*!
 * Copyright (C) 2019-2025, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 * @changelog
 *  2025-01-28 (jhoward)
 *    - Add <view-room-details-title>::adaVariants().
 *    - Add <view-room-details-title>::bedVariant().
 *    - Add <view-room-details-title>::bedOptions().
 *    - Add <view-room-details-title>::smokingVariant().
 *    - Add <view-room-details-title>::smokingVariants().
 *    - Add <view-room-details-title>::isArrayValueUnique().
 *    - Add ability to change room type in <view-room-details-title>.
*/
import {mapState, mapGetters} from 'vuex';
import {defineComponent} from "vue";
import {ViewRoomDetailsHotelRoomData} from "../hotel/defs";

export default defineComponent({
  name: "view-room-details-title",
  props: {},
  computed: {
    ...mapState([
      'currentPrtId',
      'roomData'
    ]),
    ...mapGetters([
      'currentRoomType',
      'currentRoomTypeTitleData'
    ]),
    adaVariant(): string {
      return (this.$store.getters.currentRoomTypeTitleData?.ROOM_ADA)
        ? this.$store.getters.currentRoomTypeTitleData?.ROOM_ADA_VARIANT || ''
        : '';
    },
    adaVariants(): string[] {
      const options: string[] = this.$store.state.roomData
        .map((room: ViewRoomDetailsHotelRoomData) => room.DISPLAY.ROOM_ADA_VARIANT);
      return options.filter(this.isArrayValueUnique)
        .filter((variant: string) => variant !== '');
    },
    bedVariant(): string {
      return this.$store.getters.currentRoomTypeTitleData?.ROOM_BED_VARIANT || '';
    },
    bedOptions(): string[] {
      const options: string[] = this.$store.state.roomData
        .map((room: ViewRoomDetailsHotelRoomData) => room.DISPLAY.BED_COUNT + ' ' + room.DISPLAY.BED_TYPE);
      return options.filter(this.isArrayValueUnique)
        .filter((variant: string) => variant !== '');
    },
    smokingVariant(): string {
      return (this.$store.getters.currentRoomTypeTitleData?.ROOM_SMOKING)
        ? 'Smoking'
        : 'Non-Smoking';
    },
    smokingVariants(): string[] {
      const options: string[] = [];
      for (let i = 0, l = this.$store.state.roomData.length; i < l; i++) {
        if (this.$store.state.roomData[i].DISPLAY.ROOM_SMOKING) {
          options.push('Smoking');
        } else if (this.$store.state.roomData[i].DISPLAY.ROOM_NON_SMOKING) {
          options.push('Non-Smoking');
        }
      }
      return options.filter(this.isArrayValueUnique)
        .filter((variant: string) => variant !== '');
    },
  },
  methods: {
    isArrayValueUnique(value: any, index: number, array: any[]): boolean {
      return array.indexOf(value) === index;
    }
  }
})
</script>

<style scoped>

</style>